const classesProduct = {
  hide: "hide",
  active: "is-active",
  klaviyo_bis_trigger: "klaviyo-bis-trigger",
  sale_price: "pdp-price--sale",
  unavailable: "is-unavailable",
};

const keyboardKeys = {
  ENTER: 13,
};

const selectorsProduct = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  submitButton: "[data-submit-button]",
  submitButtonText: "[data-submit-button-text]",
  klaviyo_bis_trigger: ".klaviyo-bis-trigger",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  imageWrapper: "[data-product-image-wrapper]",
  visibleImageWrapper: `[data-product-image-wrapper]:not(.tns-slide-cloned):not(.${classesProduct.hide})`,
  imageWrapperById: (id) => `${selectorsProduct.imageWrapper}:not(.tns-slide-cloned)[data-image-id='${id}']`,
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
  thumbnail: "[data-product-single-thumbnail]",
  thumbnailById: (id) => `[data-thumbnail-id='${id}']`,
  thumbnailActive: "[data-product-single-thumbnail][aria-current]",
  productGallery: "[data-product-gallery]",
  quantityInput: "[data-product-form] .js--qty-num",
  affirm: ".affirm-as-low-as",
  thumbnailContainer: ".pdp-product__thumbnail-list",
  imageZoom: ".pdp-product__image-link",
  productUnavailableText: ".pdp-unavailable-msg",
  productJson: "[data-product-json]",
  productOptionsJson: "[data-product-options-json]",
  productStockText: ".pdp-stock-message",
  metaCompare: ".b2b_sale-price",
};

function buildShippingMessage(variantShippingData) {
  if (!window.ShippingEstimate) {
    return {html: "", text: ""};
  }
  return window.ShippingEstimate.buildMessage(variantShippingData);
}

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === "function" || toStr.call(fn) === "[object Function]";
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== "undefined") {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError("Array.from: when provided, the second argument must be a function");
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === "undefined" ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  })();
}

register("product", {
  async onLoad() {
    const productFormElement = document.querySelector(selectorsProduct.productForm);

    this.lowStock = parseInt(productFormElement.dataset.lowStock || 0);
    this.productSlider = {};

    this.product = await this.getProductJson(productFormElement.dataset.productHandle);
    /*this.product = JSON.parse(
      this.container.querySelector(selectorsProduct.productJson).innerHTML
    );console.log(this.product);*/

    this.productForm = new ProductForm(productFormElement, this.product, {
      onOptionChange: this.onFormOptionChange.bind(this),
    });

    this.onThumbnailClick = this.onThumbnailClick.bind(this);
    this.onThumbnailKeyup = this.onThumbnailKeyup.bind(this);

    this.container.addEventListener("click", this.onThumbnailClick);
    this.container.addEventListener("keyup", this.onThumbnailKeyup);

    this.renderGallery();
    //this._qtySelectors();
    this.updateSwatches();

    this.initSwatchForm();

    if (document.querySelector("[tooltip-watch]")) {
      // console.log("tooltip cleared to run");
      this.initTooltip();
    }

    let variant = false;
    //check for cached param in url
    this.setCachedParam("variant");
    const submitButton = this.container.querySelector(selectorsProduct.submitButton);
    const submitButtonText = this.container.querySelector(selectorsProduct.submitButtonText);
    const idInput = this.container.querySelector(selectorsProduct.idInput);

    if (idInput && submitButton && submitButtonText) {
      if (!idInput || idInput.value == "") {
        submitButton.disabled = true;
        submitButtonText.innerText = theme.strings.selection;
      } else {
        variant = this.product.variants.filter(function (v) {
          if (v.id == idInput.value) {
            return v;
          }
          return false;
        });
        variant = variant.length == 1 ? variant[0] : false;
      }
      this.updateSelectedOption(variant);
    }

    const optionInputs = this.container.querySelectorAll(selectorsProduct.optionInput);
    optionInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        this.updateSoldoutOptions(input);
      });
    });
    this.updateSoldoutOptions();
    // const collectionSlider = document.querySelectorAll('.pdp-recommendations-slider');
    // this.initCollectionSlider(collectionSlider);
    const lpCollectionSlider = document.querySelectorAll(".recommendations-slider");
    if (lpCollectionSlider) {
      this.initCollectionSlider(lpCollectionSlider);
    }

    const scrollTrigger = document.querySelectorAll(".swatch__scroll-to");
    if (scrollTrigger) {
      scrollToTarget(scrollTrigger, 800);
    }

    const revealButton = document.querySelectorAll(".read-more-btn");
    if (revealButton) {
      this.revealContainer(revealButton);
    }

    // Paint the Shipping Time message on initial load from the variants data JSON.
    this.renderShipping(variant);

    document.querySelectorAll("#contact_swatch_request label.swatchreq-selection").forEach((el) => {
      el.addEventListener("keyup", (e) => {
        if (e.keyCode == 13) {
          el.querySelector("input.swatch_checkbox") ? el.querySelector("input.swatch_checkbox").click() : !1;
        }
      });
    });

    // Listen for upsell select/deselect events to update shipping info
    const self = this;
    const getSelectedVariant = () => {
      // Select from main product form specifically, not from upsell forms

      const variantId = document.querySelector(".pdp-addtocart-container").dataset.variantId;
      if (variantId && self.product && self.product.variants) {
        return self.product.variants.find((v) => v.id == variantId) || false;
      }
      return false;
    };

    document.addEventListener("upsell:formdata", (e) => {
      const variant = getSelectedVariant();
      self.disableAddToCartButton();
      self.updateShippingInfo(variant);
    });

    document.addEventListener("upsell:deselect", (e) => {
      const variant = getSelectedVariant();
      self.disableAddToCartButton();
      self.updateShippingInfo(variant);
    });
  },

  onUnload() {
    this.productForm.destroy();
    this.removeEventListener("click", this.onThumbnailClick);
    this.removeEventListener("keyup", this.onThumbnailKeyup);
  },

  initTooltip() {
    const tooltip = document.querySelector("[tooltip-watch]");
    const closeTooltip = document.querySelector("[tooltip-close]");
    if (!tooltip) {
      return;
    }
    tooltip.addEventListener(
      "mouseover",
      function () {
        const child = this.querySelector("[tooltip-box]");
        if (child.classList.contains("hidden")) {
          child.classList.remove("hidden");
        }
      },
      false,
    );
    tooltip.addEventListener(
      "mouseout",
      function () {
        const child = this.querySelector("[tooltip-box]");
        if (!child.classList.contains("hidden")) {
          child.classList.add("hidden");
        }
      },
      false,
    );
    if (!closeTooltip) {
      return;
    }
    closeTooltip.addEventListener("click", function () {
      if (!this.parentElement.classList.contains("hidden")) {
        this.parentElement.classList.add("hidden");
      }
    });
  },

  updateSwatches() {
    const options_container = this.container.querySelectorAll(".pdp-option-wrapper");
    options_container.forEach((el) => {
      if (el.querySelector(".pdp-option-with-image label[data-src]")) {
        const swatches_image = el.querySelectorAll(".pdp-option-with-image label[data-src]");
        let imagesLoaded = 0,
          totalImages = [...swatches_image].length;
        swatches_image.forEach((label) => {
          let img = new Image();
          let check_fallback = false;
          img.addEventListener("error", (e) => {
            if (label.getAttribute("fallback") != "" && !check_fallback) {
              check_fallback = true;
              img.src = label.getAttribute("fallback");
              if (label.querySelector("img")) {
                label.querySelector("img").src = label.getAttribute("fallback");
              }
              return;
            }

            let label_hidden = label.querySelector(".label-hidden");
            if (label_hidden) {
              label_hidden.classList.remove("label-hidden");
              label.classList.add("no-swatch-image");
            }
            let label_img = label.querySelector("img");
            if (label_img) {
              label_img.parentNode.removeChild(label_img);
            }
            el.querySelector(".pdp-option-selectors").classList.remove("pdp-option-with-image");
            el.querySelector(".pdp-option-selectors").classList.add("pdp-option-no-image");
            imagesLoaded++;
            if (imagesLoaded == totalImages) {
              allImagesLoaded(el);
            }
          });
          img.addEventListener("load", (e) => {
            let label_img = label.querySelector("img");
            if (label_img) {
              label_img.src = img.src;
              label_img.classList.remove("hide");
            }
            imagesLoaded++;
            if (imagesLoaded == totalImages) {
              allImagesLoaded(el);
            }
          });
          img.src = label.getAttribute("data-src");
        });
      }
    });
    const allImagesLoaded = function (el) {
      if (!el.querySelector("label img") || el.querySelector(".no-swatch-image")) {
        el.querySelector(".pdp-option-selectors").classList.remove("pdp-option-with-image");
        el.querySelector(".pdp-option-selectors").classList.add("pdp-option-no-image");
        el.querySelectorAll("label").forEach((label) => {
          if (label.querySelector(".label-hidden")) {
            label.querySelector(".label-hidden").classList.remove("label-hidden");
          }
          if (label.querySelector("img")) {
            label.querySelector("img").remove();
          }
        });
      }
    };
  },

  updateSelectedOption(variant) {
    const options_container = this.container.querySelectorAll(".pdp-option-wrapper");
    options_container.forEach((el) => {
      let option_label = el.querySelector(".pdp-option-label .pdp-option-selected");
      let option_checked = el.querySelector('input[name^="options["]:checked');
      if (option_checked.value != "") {
        option_label.innerHTML = option_checked.value;
      }
      let oos_el = option_label.parentNode.querySelector(".pdp-option-oos");
      if (variant && !variant.available) {
        if (!oos_el) {
          oos_el = document.createElement("span");
          oos_el.classList.add("pdp-option-oos");
          option_label.parentNode.appendChild(oos_el);
        }
        oos_el.innerText = "Out of Stock";
        //submitButtonText.innerText = theme.strings.unavailable;
      } else if (oos_el) {
        oos_el.parentNode.removeChild(oos_el);
      }
    });
  },

  renderGallery() {
    const self = this;
    const container = this.container;
    this.gallery_start = -1;
    const initGalery = function () {
      const gallery = container.querySelector(selectorsProduct.productGallery);
      if (!gallery) {
        return;
      }
      if (parseInt(self.gallery_start) == -1) {
        self.gallery_start = parseInt(gallery.getAttribute("gallery-start") || 0);
      }
      let mode = "carousel";
      if (viewportWidth() > 768) {
        mode = "gallery";
      }
      const slider = tns({
        container: gallery,
        startIndex: self.gallery_start,
        items: 1,
        mode: mode || "gallery", //carousel,gallery
        gutter: 0,
        slideBy: "page",
        center: false,
        autoplay: false,
        controls: false,
        nav: true,
        navContainer: selectorsProduct.thumbnailContainer,
        navPosition: "bottom",
        mouseDrag: true,
        disable: false,
        navAsThumbnails: false,
        lazyload: true,
        lazyloadSelector: ".lazyload",
        preventScrollOnTouch: "auto",
        onInit: function () {
          var i = 0;
          var timeout = window.setInterval(() => {
            const hide_el = gallery.querySelectorAll(".pdp-product__media");
            hide_el.forEach((el) => {
              el.classList.remove("hide");
              if (
                el.querySelector(".pdp-product__image-link.is-active") &&
                el.querySelector(".pdp-product__image-link.is-active .featured-image").classList.contains("lazyloaded")
              ) {
                clearInterval(timeout);
                el.querySelector(".pdp-product__image-link.is-active").classList.add("MagicZoomPlus");
                //el.querySelector('.pdp-product__image-link.is-active .featured-image').classList.add('lazyload');
                el.querySelector(".pdp-product__image-link.is-active").classList.remove(classesProduct.active);
                if (MagicZoom !== undefined) {
                  MagicZoom.start();
                }
              }
            });
            i++;
            if (i > 10) {
              clearInterval(timeout);
            }
          }, 500);
        },
        responsive: {
          1024: {
            mode: mode || "gallery",
            controls: false,
            nav: true,
            navAsThumbnails: true,
          },
        },
      });
      slider.events.on("indexChanged", function (info, eventName) {
        var info = slider.getInfo(),
          indexPrev = info.indexCached,
          indexCurrent = info.index;
        self.gallery_start = info.index;

        // update style based on index
        MagicZoom.stop();
        info.slideItems[indexPrev].querySelector(".pdp-product__image-link").classList.remove("MagicZoomPlus");
        info.slideItems[indexPrev].querySelector(".pdp-product__image-link").classList.remove("is-active");
        info.slideItems[indexCurrent].querySelector(".pdp-product__image-link").classList.add("MagicZoomPlus");
        info.slideItems[indexCurrent].querySelector(".pdp-product__image-link").classList.add("is-active");
        //info.slideItems[indexCurrent].querySelector('.pdp-product__image-link .featured-image').classList.add('lazyload');
        if (MagicZoom !== undefined) {
          MagicZoom.refresh();
        }
        var boundingLeftRect = document.querySelector(
          ".pdp-product__thumbnail-list .pdp-product__thumbnail.tns-nav-active",
        ).offsetLeft;
        const thumbsWidth = document.querySelector(selectorsProduct.thumbnailContainer).offsetWidth;
        if (boundingLeftRect - thumbsWidth > 0) {
          document.querySelector(selectorsProduct.thumbnailContainer).scrollTo({
            left: boundingLeftRect - 20,
            behavior: "smooth",
          });
        } else {
          document.querySelector(selectorsProduct.thumbnailContainer).scrollTo({
            left: 0,
            behavior: "smooth",
          });
        }
        let main_image_wrapper = self.container.querySelector(".pdp-product__image-viewer");
        if (main_image_wrapper) {
          main_image_wrapper.style.display = "none";
        }
        if (gallery.querySelector('.pdp-product__media .pdp-product__image-link:not([tabindex="-1"])'))
          gallery
            .querySelector('.pdp-product__media .pdp-product__image-link:not([tabindex="-1"])')
            .setAttribute("tabindex", "-1");
        gallery.querySelector(".pdp-product__media.tns-slide-active .pdp-product__image-link").removeAttribute("tabindex");
      });
      self.productSlider = slider;

      let main_image_wrapper = container.querySelector(".pdp-product__image-viewer");
      if (main_image_wrapper) {
        container.querySelector(".pdp-product__image-container .tns-outer").appendChild(main_image_wrapper);
      }
      container.querySelector(".pdp-product__image-primary")
        ? container.querySelector(".pdp-product__image-primary").style.removeProperty("visibility")
        : !1;
      /*
      window.addEventListener('resize', debounce(function(){
        if( typeof slider.destroy == 'function' ){
          //slider.destroy();
          //initGalery()
          
          if (viewportWidth() > 768) {
            initGalery('gallery');
          }else{
            initGalery('carousel');
          }
          var info = self.productSlider.getInfo(),
          indexCurrent = info.index;
          //info.slideItems[indexCurrent].querySelector('.pdp-product__image-link .featured-image').classList.add('lazyload');
        }
      }, 100),false);*/
    };

    initGalery();

    //make thumbnails scrollable by drag
    const thumbnailContainer = container.querySelector(selectorsProduct.thumbnailContainer);
    if (typeof thumbnailContainer === "defined") {
      let pos = {top: 0, left: 0, x: 0, y: 0};
      let isDown = false;
      thumbnailContainer.addEventListener("mousedown", (e) => {
        if (viewportWidth() <= 768) return;
        isDown = true;
        pos = {
          left: thumbnailContainer.scrollLeft,
          top: thumbnailContainer.scrollTop,
          // Get the current mouse position
          x: e.clientX,
          y: e.clientY,
        };
      });
      document.addEventListener("mouseup", () => {
        thumbnailContainer.classList.remove("is-drag");
        isDown = false;
      });
      thumbnailContainer.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        thumbnailContainer.classList.add("is-drag");
        //e.preventDefault();
        // How far the mouse has been moved
        const dx = e.clientX - pos.x;
        const dy = e.clientY - pos.y;

        // Scroll the element
        thumbnailContainer.scrollTop = pos.top - dy;
        thumbnailContainer.scrollLeft = pos.left - dx;
      });
    }
  },

  getProductJson(handle) {
    if (
      this.container.querySelector(selectorsProduct.productJson) &&
      this.container.querySelector(selectorsProduct.productOptionsJson)
    ) {
      let product = JSON.parse(this.container.querySelector(selectorsProduct.productJson).innerHTML);
      product.options = JSON.parse(this.container.querySelector(selectorsProduct.productOptionsJson).innerHTML);
      return product;
    }

    return fetch(`/products/${handle}.js`).then((response) => {
      return response.json();
    });
  },

  // Reads variant shipping data from the JSON script tag.
  getVariantsData() {
    if (this.variantsData) return this.variantsData;
    const el = this.container.querySelector("[data-variants-data-json]");
    this.variantsData = el ? JSON.parse(el.innerHTML) : {};
    return this.variantsData;
  },

  // Merges base variant shipping data with selected upsells.
  getEffectiveShippingData(variant) {
    const variantsData = this.getVariantsData();
    if (!variant || !variantsData[variant.id]) return null;

    const base = variantsData[variant.id];
    const effective = {
      available: !!variant.available,
      ship_date_begin: parseInt(base.ship_date_begin, 10) || 0,
      ship_date_end: parseInt(base.ship_date_end, 10) || 0,
      backorder_date: base.backorder_date || "",
      stock_notes: base.stock_notes || "",
      pre_order: !!base.pre_order,
      in_stock_newyork: base.in_stock_newyork,
      in_stock_florida: base.in_stock_florida,
      in_stock_utah: base.in_stock_utah,
    };

    const selectedUpsells = document.querySelectorAll(".pdp-upsell__actions.selected");
    if (!selectedUpsells.length) return effective;

    let effectiveBackorder = window.ShippingEstimate.normalizeBackorderDate(effective.backorder_date);
    selectedUpsells.forEach((upsell) => {
      const begin = parseInt(upsell.dataset.selectedShipDateBegin, 10) || parseInt(upsell.dataset.shipDateBegin, 10) || 0;
      const end = parseInt(upsell.dataset.selectedShipDateEnd, 10) || parseInt(upsell.dataset.shipDateEnd, 10) || 0;
      const upsellBackorder = window.ShippingEstimate.normalizeBackorderDate(
        upsell.dataset.selectedBackorderDate || upsell.dataset.backorderDate,
      );

      if (begin > effective.ship_date_begin) effective.ship_date_begin = begin;
      if (end > effective.ship_date_end) effective.ship_date_end = end;

      if (upsellBackorder) {
        if (!effectiveBackorder || new Date(upsellBackorder) > new Date(effectiveBackorder)) {
          effectiveBackorder = upsellBackorder;
          effective.backorder_date = upsellBackorder;
        }
      }
    });

    return effective;
  },

  // Updates Shipping Time in the UI and line item input.
  renderShipping(variant) {
    const container = this.container.querySelector(".pdp-shipping-info");
    const leadTimeEl = this.container.querySelector(".variant-shipping-lead-time");

    const data = this.getEffectiveShippingData(variant);
    const {html, text} = buildShippingMessage(data);

    if (leadTimeEl) {
      leadTimeEl.innerHTML = html;
    } else if (container) {
      container.innerHTML = `<div class="addtocart-info addtocart-shipping-time variant-shipping-time"><strong>Shipping Time:</strong> <span class="variant-shipping-lead-time">${html}</span></div>`;
    }

    let input = this.container.querySelector("#line-item_promise-date");
    if (text) {
      if (!input) {
        const parent = this.container.querySelector("#atc-line-item-props");
        if (parent) {
          input = document.createElement("input");
          input.id = "line-item_promise-date";
          input.name = "properties[Shipping Time]";
          parent.appendChild(input);
        }
      }
      if (input) {
        input.value = text;
        input.setAttribute("value", text);
      }
    } else if (input && input.parentNode) {
      input.parentNode.removeChild(input);
    }
  },

  updateShippingInfo(variant) {
    const atcContainer = document.querySelector(".pdp-addtocart-container");
    if (atcContainer) atcContainer.setAttribute("data-variant-id", variant ? variant.id : "");

    setTimeout(() => {
      this.renderShipping(variant);
      this.enableAddToCartButton(variant);
    }, 100);
  },

  updateSoldoutOptions(element) {
    const $container = this.container;
    const soldout_threshold = 0;
    const productSingleObject = this.product || {};
    const e = element;
    let index = "option1";
    let selected = "";
    const option_values = [];
    const optionInputs = this.container.querySelectorAll(selectorsProduct.optionInput);

    if (!this.container.querySelector(selectorsProduct.optionInput)) {
      return;
    }

    //remove low stock alert
    const option_container = $container.querySelector(".pdp-options-container").lastElementChild
      ? $container.querySelector(".pdp-options-container").lastElementChild
      : !1;
    const lowStock_el = $container.querySelectorAll(".pdp-options-container .low-stock");
    const option1_value = $container.querySelector('[name^="options"][data-option-index="option1"]')
      ? $container.querySelector('[name^="options"][data-option-index="option1"]:checked').value
      : "";
    const option2_value = $container.querySelector('[name^="options"][data-option-index="option2"]')
      ? $container.querySelector('[name^="options"][data-option-index="option2"]:checked').value
      : "";
    lowStock_el.forEach((el) => {
      el.classList.remove("low-stock");
    });

    if (e) {
      index = e.dataset.optionIndex;
      selected = e.value;
    }
    //console.log(index, productSingleObject);
    var key1 = "";
    var key2 = "";
    if (index == "option1") {
      key1 = "option2";
      key2 = "option3";
    } else if (index == "option2") {
      key1 = "option1";
      key2 = "option3";
    } else if (index == "option3") {
      key1 = "option1";
      key2 = "option2";
    }
    optionInputs.forEach((el) => {
      el.disabled = false;
    });

    const selected0 = $container.querySelector('[name^="options"][data-option-index="' + index + '"]:checked').value || "";
    const selected1 = $container.querySelector('[name^="options"][data-option-index="' + key1 + '"]')
      ? $container.querySelector('[name^="options"][data-option-index="' + key1 + '"]:checked').value
      : "";
    const selected2 = $container.querySelector('[name^="options"][data-option-index="' + key2 + '"]')
      ? $container.querySelector('[name^="options"][data-option-index="' + key2 + '"]:checked').value
      : "";

    option_values[index] = [];
    option_values[key1] = [];
    option_values[key2] = [];
    productSingleObject.variants.forEach((n, i) => {
      if (n.available) {
        //options selected
        if (selected1 != "" && selected2 != "") {
          if (n[key1] == selected1 && n[key2] == selected2) {
            option_values[index].push(n[index]);
          }
        } else if (selected1 != "") {
          if (n[key1] == selected1) {
            option_values[index].push(n[index]);
          }
        } else if (selected2 != "") {
          if (n[key2] == selected2) {
            option_values[index].push(n[index]);
          }
        } else {
          option_values[index].push(n[index]);
        }
        //options key1
        if (selected0 != "" && selected2 != "") {
          if (n[index] == selected0 && n[key2] == selected2) {
            option_values[key1].push(n[key1]);
          }
        } else if (selected0 != "") {
          if (n[index] == selected0) {
            option_values[key1].push(n[key1]);
          }
        } else if (selected2 != "") {
          if (n[key2] == selected2) {
            option_values[key1].push(n[key1]);
          }
        } else {
          option_values[key1].push(n[key1]);
        }

        //options key2
        if (selected0 != "" && selected1 != "") {
          if (n[index] == selected0 && n[key1] == selected1) {
            option_values[key2].push(n[key2]);
          }
        } else if (selected0 != "") {
          if (n[index] == selected0) {
            option_values[key2].push(n[key2]);
          }
        } else if (selected1 != "") {
          if (n[key1] == selected1) {
            option_values[key2].push(n[key2]);
          }
        } else {
          option_values[key2].push(n[key2]);
        }
      }
      option_values[index] = Array.from(new Set(option_values[index]));
      option_values[key1] = Array.from(new Set(option_values[key1]));
      option_values[key2] = Array.from(new Set(option_values[key2]));

      optionInputs.forEach((input) => {
        let option_index = input.dataset.optionIndex;
        let disable = false;
        if (option_values[option_index].includes(input.value)) {
          disable = true;
          //input.disabled = false;
          input.classList.remove("disabled");
          //input.nextElementSibling.
        } else {
          //input.disabled = true;
          input.classList.add("disabled");
        }
      });

      //update low stock alert
      const lowStock = this.lowStock;
      const optionInput1 = $container.querySelector('[name^="options"][data-option-index="option1"]');
      const optionInput2 = $container.querySelector('[name^="options"][data-option-index="option2"]');
      const optionInput3 = $container.querySelector('[name^="options"][data-option-index="option3"]');
      //console.log(option1_value,option2_value, n.options[0],n.options[1]);
      if (
        lowStock > 0 &&
        n.available &&
        n.inventory_quantity <= lowStock &&
        n.inventory_policy != "continue" &&
        n.inventory_management != null &&
        (option1_value != "" || (option2_value != "" && option_container))
      ) {
        let inputLabel = option_container.querySelectorAll("label span");
        //console.log(lowStock, n);
        //console.log(n);
        inputLabel.forEach((label) => {
          if (
            optionInput1 &&
            optionInput2 &&
            optionInput3 &&
            option1_value == n.option1 &&
            option2_value == n.option2 &&
            label.innerText == n.option3
          ) {
            label.classList.add("low-stock");
          } else if (
            optionInput1 &&
            optionInput2 &&
            !optionInput3 &&
            option1_value == n.option1 &&
            label.innerText == n.option2
          ) {
            label.classList.add("low-stock");
          } else if (optionInput1 && !optionInput2 && !optionInput3 && label.innerText == n.option1) {
            label.classList.add("low-stock");
          }
        });
      }
    });
  },

  onFormOptionChange(event) {
    const variant = event.dataset.variant;
    this.renderImages(event);

    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);
    this.updateMaxQty(variant);
    this.disableAddToCartButton();
    this.updateShippingInfo(variant);
    this.updateSelectedOption(variant);

    this.updateBrowserHistory(variant);
    this.updateVariantReturnable(variant);
    this.updateVariantMadeToOrder(variant);
    this.updateVariantData(variant);
  },

  setCachedParam(val) {
    const urlParams = new URLSearchParams(window.location.search);
    const existingParam = urlParams.get(val);
    // this.renderCurrentSku(existingParam);
  },

  setCurrentSku(val) {
    this.renderCurrentSku(val);
  },

  renderCurrentSku(val) {
    if (val != null) {
      const buyBoxSku = document.querySelector(".renderSku2-js");
      const descriptionSku = document.querySelector(".renderSku-js");
      buyBoxSku.innerHTML = val;
      descriptionSku.innerHTML = val;
    }
  },

  onThumbnailClick(event) {
    const thumbnail = event.target.closest(selectorsProduct.thumbnail);

    if (!thumbnail) {
      return;
    }

    event.preventDefault();

    let main_image_wrapper = this.container.querySelector(".pdp-product__image-viewer");
    if (main_image_wrapper) {
      main_image_wrapper.style.display = "none";
    }

    //this.renderFeaturedImage(thumbnail.dataset.thumbnailId);
    this.renderActiveThumbnail(thumbnail.dataset.thumbnailId);
  },

  onThumbnailKeyup(event) {
    if (event.keyCode !== keyboardKeys.ENTER || !event.target.closest(selectorsProduct.thumbnail)) {
      return;
    }

    const visibleFeaturedImageWrapper = this.container.querySelector(selectorsProduct.visibleImageWrapper);

    forceFocus(visibleFeaturedImageWrapper);
  },

  disableAddToCartButton() {
    const submitButton = this.container.querySelector(selectorsProduct.submitButton);
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute("aria-disabled", "true");
    }
  },

  enableAddToCartButton(variant) {
    const submitButton = this.container.querySelector(selectorsProduct.submitButton);
    if (!submitButton) return;

    // Only enable if variant is available
    if (variant && variant.available) {
      submitButton.disabled = false;
      submitButton.setAttribute("aria-disabled", "false");
    }
  },

  renderSubmitButton(variant) {
    let selected_all = true;
    const options_container = this.container.querySelectorAll(".pdp-option-wrapper");
    options_container.forEach((el) => {
      if (!el.querySelector('[name^="options"]:checked') || el.querySelector('[name^="options"]:checked').value == "") {
        selected_all = false;
      }
    });

    const submitButton = this.container.querySelector(selectorsProduct.submitButton);
    const submitButtonText = this.container.querySelector(selectorsProduct.submitButtonText);

    if (!submitButton) {
      return;
    }

    // Disable button if not all options are selected
    if (!selected_all) {
      submitButton.disabled = true;
      submitButton.setAttribute("aria-disabled", "true");
      submitButtonText.innerText = theme.strings.selection || "Make a Selection";
      return;
    }

    const klaviyo_bis_trigger = this.container.querySelector(selectorsProduct.klaviyo_bis_trigger);
    const unavailableText = this.container.querySelector(selectorsProduct.productUnavailableText);
    const stockText = this.container.querySelector(selectorsProduct.productStockText);
    const productFormElement = document.querySelector(selectorsProduct.productForm);
    const Bis_enable = productFormElement.dataset.bisEnable || false;

    if (klaviyo_bis_trigger) {
      klaviyo_bis_trigger.style.display = "none";
      klaviyo_bis_trigger.classList.add("hide");
      this.container.querySelector(".pdp-addtocart-container").classList.remove("bis-show");
    }

    submitButton.classList.remove("hide");
    submitButton.style.display = "block";
    unavailableText.classList.add("hide");
    stockText.classList.remove("hide");

    if (variant) {
      if (
        this.lowStock > 0 &&
        variant.inventory_quantity == this.lowStock &&
        variant.inventory_policy != "continue" &&
        variant.inventory_management != ""
      ) {
        stockText.innerHTML = "Low stock";
      } else if (
        variant.inventory_quantity > 0 &&
        this.lowStock > 0 &&
        variant.inventory_quantity < this.lowStock &&
        variant.inventory_policy != "continue" &&
        variant.inventory_management != ""
      ) {
        stockText.innerHTML = `${variant.inventory_quantity} Low stock`;
      } else if (variant.available == false && Bis_enable == false) {
        stockText.innerHTML = theme.strings.soldOut;
      } else {
        stockText.innerHTML = "";
      }
    }

    if (!variant || variant == null) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
      submitButton.classList.add(classesProduct.unavailable);
      if (unavailableText) {
        unavailableText.classList.remove("hide");
        stockText.classList.add("hide");
        submitButton.style.display = "block";
      }
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
      submitButton.classList.remove(classesProduct.unavailable);
      if (klaviyo_bis_trigger) {
        klaviyo_bis_trigger.classList.add("hide");
        klaviyo_bis_trigger.style.display = "none";
      }
      submitButton.classList.remove("hide");
      submitButton.style.display = "block";
    } else {
      // Variant is not available (out of stock)
      if ((Bis_enable === true || Bis_enable == "true") && klaviyo_bis_trigger) {
        // Show Klaviyo back-in-stock button
        if (viewportWidth() > 768) {
          klaviyo_bis_trigger.innerText = theme.strings.notify;
        } else {
          klaviyo_bis_trigger.innerText = theme.strings.notify_mobile;
        }
        klaviyo_bis_trigger.classList.remove("hide");
        klaviyo_bis_trigger.style.display = "block";
        submitButton.classList.add("hide");
        submitButton.style.display = "none";
        stockText.classList.add("hide");
        this.container.querySelector(".pdp-addtocart-container").classList.add("bis-show");
      } else {
        // No BIS enabled, show disabled sold out button
        submitButton.classList.remove("hide");
        submitButton.style.display = "block";
      }
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.soldOut;
      submitButton.classList.remove(classesProduct.unavailable);
    }
  },

  updateMaxQty(variant) {
    const quantityInput = this.container.querySelector(selectorsProduct.quantityInput);
    if (!variant || variant.inventory_policy != "deny" || variant.inventory_management == null) {
      quantityInput.removeAttribute("max");
      return;
    }
    let cartItems = {};
    if (this.container.querySelector("[data-cartitems-json]")) {
      cartItems = JSON.parse(this.container.querySelector("[data-cartitems-json]").innerHTML);
    }
    let variant_incart = 0;
    if (cartItems && cartItems[variant.id] && cartItems[variant.id] != undefined) {
      variant_incart = parseInt(cartItems[variant.id]);
    }
    let inventory_quantity = variant.inventory_quantity;
    let maxQty = inventory_quantity;
    maxQty -= variant_incart;
    maxQty = maxQty > 1 ? maxQty : 1;

    quantityInput.setAttribute("max", maxQty);
    if (parseInt(quantityInput.value) > maxQty) {
      quantityInput.value = maxQty;
    }
    const submitButton = this.container.querySelector(selectorsProduct.submitButton);
    const productFormElement = document.querySelector(selectorsProduct.productForm);
    // productFormElement.addEventListener('submit', (e) => {
    //   e.preventDefault();
    //   if((variant_incart+parseInt(quantityInput.value))>inventory_quantity) {
    //     window.location.href='/cart';
    //     return;
    //   }
    //   productFormElement.submit();
    // })
  },

  updateVariantData(variant) {
    let variantsData = {};
    let vendor_notes_input = this.container.querySelector("#line-item_vendor-notes");
    let parent_line_properties = this.container.querySelector("#atc-line-item-props");
    if (this.container.querySelector("[data-variants-data-json]")) {
      variantsData = JSON.parse(this.container.querySelector("[data-variants-data-json]").innerHTML);
    }
    if (!Object.keys(variantsData).length || !variant) {
      vendor_notes_input ? parent_line_properties.removeChild(vendor_notes_input) : !1;
      return;
    }

    let vendor_notes = variantsData[variant.id]["vendor_notes"];
    if (vendor_notes != "" && vendor_notes != null) {
      if (!vendor_notes_input) {
        vendor_notes_input = document.createElement("input");
        vendor_notes_input.id = "line-item_vendor-notes";
        vendor_notes_input.value = vendor_notes;
        vendor_notes_input.name = "properties[_VENDOR Notes]";
        parent_line_properties.appendChild(vendor_notes_input);
      }
      vendor_notes_input.setAttribute("value", vendor_notes);
    } else {
      vendor_notes_input ? vendor_notes_input.parentNode.removeChild(vendor_notes_input) : !1;
    }
  },

  updateVariantReturnable(variant) {
    let returnsVariants = {};
    if (this.container.querySelector("[data-variant-returnable-json]")) {
      returnsVariants = JSON.parse(this.container.querySelector("[data-variant-returnable-json]").innerHTML);
    }

    if (variant) {
      document.querySelectorAll("[data-variant-non-returnable]").forEach((el) => {
        if (variant && returnsVariants[variant.id] && returnsVariants[variant.id] == "false") {
          el.style.display = "block";
        } else {
          el.style.display = "none";
        }
      });
      document.querySelectorAll("[data-variant-returnable]").forEach((el) => {
        if (variant && returnsVariants[variant.id] && returnsVariants[variant.id] == "false") {
          el.style.display = "none";
        } else {
          el.style.display = "block";
        }
      });
    }
  },

  updateVariantMadeToOrder(variant) {
    let variantsMto = "";
    const tooltip = this.container.querySelector("[tooltip-watch]");
    if (!tooltip || !variant) return;
    variantsMto = tooltip.dataset.madeToOrder || "";
    variantsMto = variantsMto.split(",");

    if (variant && variantsMto.indexOf(variant.id.toString()) != -1) {
      tooltip.classList.remove("hide");
      document.querySelectorAll(".product-nonreturnable").forEach((el) => {
        const messaging = el.closest(".pdp-messaging");
        if (messaging) messaging.style.display = "none";
      });
    } else {
      tooltip.classList.add("hide");
      //$('.product-nonreturnable').closest('.pdp-messaging').show();
    }
    document.querySelectorAll("[data-variant-mto]").forEach((el) => {
      if (variant && variantsMto.indexOf(variant.id.toString()) != -1) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    });
    document.querySelectorAll("[data-variant-non-mto]").forEach((el) => {
      if (variant && variantsMto.indexOf(variant.id.toString()) != -1) {
        el.style.display = "none";
      } else {
        el.style.display = "block";
      }
    });

    // Control layout based on what is visible.
    // Read the resolved value: these elements are hidden from a stylesheet, so the
    // inline style property would be empty here.
    const displayOf = (selector) => {
      const el = document.querySelector(selector);
      return el ? window.getComputedStyle(el).display : null;
    };
    const setMoreOptionsPadding = (value) => {
      document.querySelectorAll(".more-options-text-wrap").forEach((el) => {
        el.style.paddingTop = value;
      });
    };

    const customMadeDisplay = displayOf(".custom-made-wrap");
    const noRefundDisplay = displayOf(".no-refund-wrap");

    if (customMadeDisplay == "none" && noRefundDisplay == "none") {
      setMoreOptionsPadding("32px");
    } else if (customMadeDisplay == "block" && noRefundDisplay == "none") {
      setMoreOptionsPadding("0px");
    }
  },

  renderImages(event) {
    const variant = event.dataset.variant;
    let thumb_featured_image_wrapper = this.container.querySelector(
      ".pdp-product__thumbnail--featured .pdp-product__thumbnail-link",
    );
    let main_image_wrapper = this.container.querySelector(".pdp-product__media--featured .pdp-product__image-link");
    //main_image_wrapper = main_image_wrapper ? main_image_wrapper : this.container.querySelector('.pdp-product__image-viewer');
    main_image_wrapper = this.container.querySelector(".pdp-product__image-viewer");
    thumb_featured_image_wrapper = null;
    const target = event.target;
    //const info = this.productSlider.getInfo();
    //let indexCurrent = info.index;
    let image_id = target.getAttribute("data-viewer-image-id");
    const container = this.container;
    let use_variant_image = false;
    if (image_id == "" && variant && variant.featured_image && variant.featured_image.id) {
      image_id = variant.featured_image.id;
      use_variant_image = true;
    }
    const imageviewer =
      image_id != "" && image_id != null ? this.container.querySelector(selectorsProduct.thumbnailById(image_id)) : false;
    if (imageviewer && !imageviewer.classList.contains("pdp-product__thumbnail--featured")) {
      if (main_image_wrapper) {
        main_image_wrapper.style.display = "none";
      }
      this.container.querySelector(".pdp-product__image-primary")
        ? this.container.querySelector(".pdp-product__image-primary").style.removeProperty("visibility")
        : !1;
      imageviewer.click();
    } else if (image_id != "" && image_id != null) {
      MagicZoom.stop();
      if (!main_image_wrapper) {
        main_image_wrapper = document.createElement("a");
        main_image_wrapper.classList.add("pdp-product__image-viewer");
        main_image_wrapper.classList.add("pdp-product__image-viewer");
        main_image_wrapper.setAttribute("data-options", "rightClick:true; zoomMode: off");
        main_image_wrapper.setAttribute("data-mobile-options", "zoomMode: off");
        let $wrapper = this.container.querySelector(".pdp-product__image-container .tns-outer");
        if (typeof $wrapper === "defined") {
          $wrapper.appendChild(main_image_wrapper);
        }
      }
      main_image_wrapper.style.display = "none";
      this.container.querySelector(".pdp-product__image-primary")
        ? (this.container.querySelector(".pdp-product__image-primary").style.visibility = "hidden")
        : !1;
      if (thumb_featured_image_wrapper) {
        thumb_featured_image_wrapper.style.display = "none";
      }
      main_image_wrapper.href = target.getAttribute("data-viewer-image-zoom");
      if (use_variant_image) {
        main_image_wrapper.href = variant.featured_image.src;
        const match = main_image_wrapper.href.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (match) {
          const prefix = main_image_wrapper.href.split(match[0]);
          const suffix = match[0];
          main_image_wrapper.href = `${prefix[0]}_1024x1024.progressive${suffix}`;
        }
      }
      let img = main_image_wrapper.querySelector("img");
      if (!img) {
        img = document.createElement("img");
        main_image_wrapper.appendChild(img);
      }
      let image_src = target.getAttribute("data-viewer-image");
      if (use_variant_image) {
        image_src = main_image_wrapper.href;
      }
      img.src = image_src;
      img.setAttribute("data-src", image_src);
      /*
      main_image_wrapper.style.display = 'block';

      //swicth thubnail image
      let thumb_img = thumb_featured_image_wrapper.querySelector('img');
      if ( !thumb_img ) {
        thumb_img = document.createElement('img');
        thumb_featured_image_wrapper.appendChild(thumb_img);
      }
      //thumb_img.src = image_src.replace('1024x1024.progressive.', '300x.progressive.');
      thumb_featured_image_wrapper.style.display = 'block';
      */

      window.setTimeout(function () {
        /*
        if ( thumb_featured_image_wrapper ) {
          thumb_featured_image_wrapper.click();
        }*/
        if (MagicZoom !== undefined) {
          main_image_wrapper.classList.add("MagicZoomPlus");
          MagicZoom.refresh();
        } else {
          MagicZoom.start();
        }
        main_image_wrapper.style.display = "block";
        container.querySelector(".pdp-product__image-primary")
          ? container.querySelector(".pdp-product__image-primary").style.removeProperty("visibility")
          : !1;
      }, 300);
    }

    if (!variant || variant.featured_image === null) {
      return;
    }
    //this.renderFeaturedImage(variant.featured_image.id);
    this.renderActiveThumbnail(variant.featured_image.id);
  },

  renderPrice(variant) {
    const priceElement = this.container.querySelector(selectorsProduct.productPrice);
    const priceWrapperElement = this.container.querySelector(selectorsProduct.priceWrapper);

    //priceWrapperElement.classList.toggle(classesProduct.hide, !variant);

    if (variant) {
      priceElement.innerText = formatMoney(variant.price, theme.moneyFormat);
      const affirmElement = this.container.querySelector(selectorsProduct.affirm);
      if (affirmElement) {
        affirmElement.setAttribute("data-amount", variant.price);
        affirm.ui.ready(function () {
          affirm.ui.refresh();
        });
      }
      const priceElement1 = this.container.querySelector(".pdp-addtocart-container " + selectorsProduct.productPrice);
      if (priceElement1) {
        priceElement1.innerText = formatMoney(variant.price, theme.moneyFormat);
      }

      // Update the product-form base price for upsell total calculation
      const productForm = this.container.querySelector('product-form[data-accept-upsell="true"]');
      if (productForm && typeof productForm.updateBasePrice === "function") {
        productForm.updateBasePrice(variant.price);
      }

      // Dispatch variant changed event for price tracking
      document.dispatchEvent(
        new CustomEvent("variant:changed", {
          detail: {price: variant.price, variantId: variant.id},
        }),
      );
    }
  },

  renderComparePrice(variant) {
    if (!variant) {
      return;
    }
    const priceWrapperElement = this.container.querySelector(selectorsProduct.priceWrapper);
    const comparePriceElement = this.container.querySelector(selectorsProduct.comparePrice);
    const compareTextElement = this.container.querySelector(selectorsProduct.comparePriceText);
    const compareMeta = this.container.querySelector(selectorsProduct.metaCompare);

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    const prodUrl = priceWrapperElement.getAttribute("data-product-url");
    const varID = variant.id;

    const getCompare = (id) => {
      return fetch(prodUrl + "?view=json")
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          var result = data.variant_list.variants.find((obj) => {
            return obj.id === id;
          });
          return result;
        });
    };

    // If B2B — need to get the retail compare at prices off the variant metafield. Requires a Fetch to product json endpoint
    if (prodUrl) {
      getCompare(varID).then((variantMetaCompare) => {
        const retailNumber = variantMetaCompare.retail_price;
        const retailDecimalValue = retailNumber ? retailNumber.toString().indexOf(".") : false;
        const retailResult = retailDecimalValue ? retailNumber.toString().substring(retailDecimalValue + 1) : false;

        const compareNumber = variantMetaCompare.retail_compare_at;
        const compareDecimalValue = compareNumber ? compareNumber.toString().indexOf(".") : false;
        const compareResult = compareDecimalValue ? compareNumber.toString().substring(compareDecimalValue + 1) : false;

        const variantMetaRetailPrice =
          retailResult == "0" ? variantMetaCompare.retail_price * 100 : parseInt(variantMetaCompare.retail_price * 100);
        const variantMetaComparePrice =
          compareResult == "0"
            ? variantMetaCompare.retail_compare_at * 100
            : parseInt(variantMetaCompare.retail_compare_at * 100);
        const onSale = variantMetaCompare.on_sale;

        if (variant.price < variantMetaRetailPrice || variant.price < variantMetaComparePrice) {
          if (variantMetaComparePrice && variantMetaComparePrice > variant.price) {
            comparePriceElement.innerText = formatMoney(variantMetaComparePrice, theme.moneyFormat);
          } else {
            comparePriceElement.innerText = formatMoney(variantMetaRetailPrice, theme.moneyFormat);
          }
          compareTextElement.classList.remove(classesProduct.hide);
          comparePriceElement.classList.remove(classesProduct.hide);
          if (onSale == "true") {
            priceWrapperElement.classList.add(classesProduct.sale_price);
            compareMeta.classList.add("red");
          } else {
            priceWrapperElement.classList.remove(classesProduct.sale_price);
            compareMeta.classList.remove("red");
          }
        } else if (variant.price == variantMetaRetailPrice) {
          comparePriceElement.innerText = "";
          if (variantMetaComparePrice && variantMetaComparePrice > variant.price) {
            comparePriceElement.innerText = formatMoney(variantMetaComparePrice, theme.moneyFormat);
          }
          compareTextElement.classList.remove(classesProduct.hide);
          comparePriceElement.classList.remove(classesProduct.hide);
          if (onSale == "true") {
            priceWrapperElement.classList.add(classesProduct.sale_price);
            compareMeta.classList.add("red");
          } else {
            priceWrapperElement.classList.remove(classesProduct.sale_price);
            compareMeta.classList.remove("red");
          }
        } else {
          comparePriceElement.innerText = "";
          compareTextElement.classList.add(classesProduct.hide);
          comparePriceElement.classList.add(classesProduct.hide);
          priceWrapperElement.classList.remove(classesProduct.sale_price);
        }
      });
    } else {
      if (variant.compare_at_price > variant.price) {
        comparePriceElement.innerText = formatMoney(variant.compare_at_price, theme.moneyFormat);
        compareTextElement.classList.remove(classesProduct.hide);
        comparePriceElement.classList.remove(classesProduct.hide);
        priceWrapperElement.classList.add(classesProduct.sale_price);
      } else {
        comparePriceElement.innerText = "";
        compareTextElement.classList.add(classesProduct.hide);
        comparePriceElement.classList.add(classesProduct.hide);
        priceWrapperElement.classList.remove(classesProduct.sale_price);
      }
    }
  },

  renderActiveThumbnail(id) {
    const activeThumbnail = this.container.querySelector(selectorsProduct.thumbnailById(id));
    const inactiveThumbnail = this.container.querySelector(selectorsProduct.thumbnailActive);
    if (activeThumbnail === inactiveThumbnail || !activeThumbnail || !inactiveThumbnail) {
      return;
    }

    inactiveThumbnail.removeAttribute("aria-current");
    activeThumbnail.setAttribute("aria-current", true);
    inactiveThumbnail.classList.remove(classesProduct.active);
    activeThumbnail.classList.add(classesProduct.active);
    activeThumbnail.click();
  },

  renderFeaturedImage(id) {
    const activeImage = this.container.querySelector(selectorsProduct.visibleImageWrapper);
    const inactiveImage = this.container.querySelector(selectorsProduct.imageWrapperById(id));

    activeImage.classList.add(classesProduct.hide);
    inactiveImage.classList.remove(classesProduct.hide);
  },

  updateBrowserHistory(variant) {
    const enableHistoryState = this.productForm.element.dataset.enableHistoryState;

    if (!variant || enableHistoryState !== "true") {
      return;
    }

    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({path: url}, "", url);

    this.setCurrentSku(variant.sku);
  },

  _qtySelectors() {
    const $body = document.querySelector("body");
    // Qty selector has a minimum of 1 on the product page
    // and 0 in the cart (determined on qty click)
    let qtyMin = 1;
    const qtyadjuster = document.querySelectorAll(".js--qty-adjuster");
    qtyadjuster.forEach((adj) => {
      adj.removeEventListener("click", (e) => {});
    });
    qtyadjuster.forEach((adj) => {
      adj.addEventListener("click", (e) => {
        e.preventDefault();
        let el = adj,
          //id = el.data('id'),
          qtySelector = el.parentNode.querySelector(".js--qty-num"),
          qty = parseInt(qtySelector.value.replace(/\D/g, ""));
        // Make sure we have a valid integer
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        if ($body.classList.contains("template-cart")) {
          qtyMin = 0;
        }
        // Add or subtract from the current quantity
        if (el.classList.contains("js--add")) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= qtyMin) qty = qtyMin;
        }
        // Update the input's number
        qtySelector.value = qty;
      });
    });
  },

  revealContainer(selector) {
    selector.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.target.parentNode.classList.toggle("active-wrapper");
        if (el.classList.contains("reveal-show-title")) {
          el.parentNode.classList.add("no-bottom-padding");
          el.classList.toggle("reveal-show-title");
          // const gradBorder = el.closest('.pdp-grad-border');
          // console.log('GRAD BORDER: ' + gradBorder)
          el.style.display = "none";
          // gradBorder.style.display = "none";
        }
      });
    });
  },

  initCollectionSlider(sliders) {
    if (sliders.length > 0) {
      sliders.forEach((el) => {
        var slider = tns({
          container: el,
          items: 2,
          gutter: 20,
          slideBy: "page",
          center: false,
          autoplay: false,
          controls: true,
          nav: true,
          navPosition: "bottom",
          mouseDrag: true,
          preventScrollOnTouch: "auto",
          responsive: {
            768: {
              items: 4,
            },
          },
        });
      });
    }
  },

  initSwatchForm() {
    const formSwatch = document.getElementById("contact_swatch_request");
    const $recaptcha = document.querySelector("#g-recaptcha-response");
    if (document.body.contains(formSwatch)) {
      formSwatch.addEventListener("submit", async function (event) {
        event.preventDefault();
        const form = event.target;
        var swatch = new Array();
        var user_swatches_comments = "";
        var comments = document.querySelector("#user_comments") ? document.querySelector("#user_comments").value : "";
        let checkboxs = form.querySelectorAll('input[type="checkbox"]:checked');
        checkboxs.forEach((cb) => {
          swatch.push(cb.getAttribute("data-variant-name"));
          if (swatch.length > 0) {
            user_swatches_comments = "Selected swatches: " + swatch.join(",") + " , User Comments: " + comments;
            document.querySelector("#description")
              ? (document.querySelector("#description").value = user_swatches_comments)
              : !1;
          }
        });
        /*
        var data = new FormData();
        for (var i = 0; i < formEl.length; ++i) {
          data.append(formEl[i].name, formEl[i].value);
        }*/
        const data = new URLSearchParams(new FormData(form));
        fetch(form.action, {
          method: "POST",
          mode: "no-cors",
          body: data,
        })
          .then(function (response) {
            return response.text();
          })
          .then((response) => {
            console.log("completed ok");
            document.querySelector("#contact_swatch_request").reset();
            document.querySelector("#thank-you-swatch-form").style.display = "block";
            document.querySelector("#submit-swatchreq").style.display = "none";
            document.querySelector(".g-recaptcha").style.display = "none";
          })
          .catch((error) => console.error("Error:", error));
      });
      if ($recaptcha) {
        $recaptcha.setAttribute("required", "required");
      }
    }
  },
});

load("product");
